import React from 'react';
import { Link, Match, redirectTo } from '@reach/router';

function BackLink() {
  return (
    <Link className="row-start align-center -accent" to="/">
      <div aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="30"
          width="20"
          viewBox="10 0 10 20"
        >
          <path
            fill="var(--accent)"
            d="M13.36 17a1 1 0 01-.72-.31l-3.86-4a1 1 0 010-1.4l4-4a1 1 0 111.42 1.42L10.9 12l3.18 3.3a1 1 0 010 1.41 1 1 0 01-.72.29z"
          />
        </svg>
      </div>
      VOLVER
    </Link>
  );
}

export default BackLink;
